<template>
  <v-layout row>
    <v-flex sm6 md8>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            dense
            label="Arrive Date"
            v-model="formData.date"
            outlined
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="formData.date"
          @input="menu = false"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs5 sm6 md4 lg4 xl3 px-1 pr-1 grow>
      <SimpleTextInput
        label="Time"
        v-mask="mask"
        :placeholder="'00:00'"
        v-model="formData.time"
      ></SimpleTextInput>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import { Overwatch } from "@/components/util/Overwatch.js";


import { mask } from "vue-the-mask";
import moment from 'moment'

export default {
  name: "DateAndTimeInput",
  directives: {
    mask
  },
  components: {
    SimpleTextInput
  },
  props: {
    label: String,
    required: Boolean,
    errorMessages: Object,
    formData: Object,
  },
  watch: {
  },
  computed: {
  
  },
  data() {
    return {
      mask: "##:##",
      menu: false,
    };
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.now-toggle {
  cursor: pointer;
  padding-left: 6px;
  padding-right: 6px;
  height: 24px;
  width: 36px;
  font-size: 11px;
  text-align: center;
}

.future-toggle {
  cursor: pointer;
  background-color: lightgray;
  padding-left: 6px;
  padding-right: 6px;
  height: 24px;
  width: 26px;
  font-size: 11px;
  text-align: center;
}

.left {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.right {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.centered-p {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.dense {
  font-size: 8pxx ;
}
</style>
